import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps, BlockIntentStyles } from '../common/props';
import { ContainerProps } from '../types';

export interface IBlockProps extends Omit<BaseProps, 'title'> {
  title?: React.ReactNode;
  /**
   * Pokud je true, nezalamuje se dlouhý text do více řádků a aplikují se tři tečky, sndardně se text zalamuje.
   */
  noWrap?: boolean;
  extra?: React.ReactNode;
  /**
   * Pokud se jedná o blok EDIT, tak se automaticky předpokládá, že součástí jsou form itemy a dle toho se upravuje spodní odsazení. Pokud by posledním prvkem v tomto bloku nebyla form item (např. string input apod.), tak lze automatickou úpravu odsazení tímto příznakem vypnout.
   */
  noFormItemsContent?: boolean;
  /**
   * Automaticky na blocku nastaví hover, lze vypnout pomocí parametru disableHover.
   */
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  /**
   * Vypne hover, spuštěný automaticky na blocku s parametrem onClick.
   */
  disableHover?: boolean;
  /**
   * Classname na celý kontejner - wrappper, který obsahuje header a body, přes toto nejde např. tylovat padding v body, na to je nutné použít bodyClassname. Vhodné např. pro hover container apod.
   */
  className?: string;
  /**
   * Classname pro body, vhodné např. pro padding apod.
   */
  bodyClassName?: string;
  /**
   * Classname pro header.
   */
  headerClassName?: string;
  /**
   * Typ nadpisu na blocku, pokud není uvedeno, je none.
   */
  intent?: BlockIntentStyles;
}

export type BlockProps = IBlockProps & ContainerProps;

/**
 * Komponenta obsahu kartičky.
 */
export class Block extends React.PureComponent<BlockProps> {
  render() {
    const {
      noWrap,
      className,
      bodyClassName,
      headerClassName,
      children,
      title,
      extra,
      disableHover,
      intent,
      fullHeight,
      maxFullHeight,
      noScroll,
      onClick,
      ...other
    } = this.props;

    let cls = classNames(Classes.BLOCK, className, Classes.HOVER_CONTAINER, {
      [Classes.HOVER_ITEM_CONTAINER]: !disableHover && onClick,
      [Classes.CLICK_CONTAINER]: onClick,
      [Classes.CONTAINER_FULL_HEIGHT]: fullHeight,
      [Classes.CONTAINER_MAX_HEIGHT]: maxFullHeight,
      [Classes.NO_SCROLL]: noScroll,
    });

    return (
      <div onClick={onClick} {...other} className={cls}>
        {(title || extra) && (
          <div className={classNames(Classes.BLOCK_HEADER, headerClassName)}>
            <div
              className={classNames(Classes.BLOCK_HEADER_TITLE, {
                [Classes.BLOCK_HEADER_TITLE_NO_WRAP]: noWrap,
                [Classes.BLOCK_HEADER_TITLE_INACTIVE]: intent === 'inactive',
              })}
            >
              {title}
            </div>
            <div className={Classes.BLOCK_HEADER_EXTRA}>{extra}</div>
          </div>
        )}
        {children && (
          <div className={classNames(Classes.BLOCK_BODY, bodyClassName)}>
            {children}
          </div>
        )}
      </div>
    );
  }
}
